import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { history } from "../../../Helpers/history";
import { useReusableNewSales } from "./useReusableNewSales";
import { validateCurrentDate } from "../../../Utils/ConvertDate";

const paymentMethods = [
  { label: "MTN" },
  { label: "Airtel" },
  { label: "Cash" },
  // { label: "VISA" },
  { label: "Bank" },
];
export const useNewReceipt = (actions, invoice_number = "") => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const singleUser = !user ? {} : user;
  const user_id = !singleUser.user_id ? 1 : singleUser.user_id;
  const [submitted, setSubmitted] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [invoice_id, setInvoiceId] = useState("");
  const [isSubmitted, setIsSubmitted] = useState("idle");
  const [payTypes, setPayTypes] = useState([]);
  const [receiptData, setReceiptData] = useState({
    products: [],
    customer: {},
    loading: "idle",
  });
  const { stateFunctions, stateVariables } = useReusableNewSales(
    actions,
    invoice_number,
    true,
  );
  const {
    customer,
    rows,
    customerDetails,
    totals,
    initialState,
    state,
    paytype,
  } = stateVariables;
  const { setRows, setCustomer, setTotals, setCustomerDetails, setIsBlocking } =
    stateFunctions;
  const { customer_id } = customer;

  useEffect(() => {
    setCustomer({ customer_name: "Walk-in Customer", customer_id: 1 });
  }, []);

  useEffect(() => {
    // axios
    //   .get(`${config.epharmUrl}/Cinvoice/payment_types`)
    //   .then((res) => {
    //     const data = res.data;
    //     const dt = !data.data ? [] : data.data;
    //     const arr = dt
    //       .map((item) => ({
    //         value: item.id,
    //         text: item.payment_type_name,
    //       }))
    //       .filter((item) => item.text !== "CREDIT");
    //     setPayTypes(arr);
    //   })
    //   .catch((error) => {
    //     errorMessages(error, null, actions);
    //   });
    try {
      const arr = paymentMethods
        .map((item, index) => ({
          value: index + 1,
          text: item.label,
        }))
        .filter((item) => item.text !== "CREDIT");
      setPayTypes(arr);
    } catch (error) {
      errorMessages(error, null, actions);
    }
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const retrieveReceiptDetails = (item) => {
    const { receipt_number: recep_number, customer_id: cus_id } = item;
    const formData = new FormData();
    formData.append("receipt_number", recep_number);
    formData.append("invoice_number", "");
    formData.append("customer_id", cus_id);
    setReceiptData({ ...receiptData, loading: "loading" });
    axios
      .post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        const dataRes = response.data;
        const dt = dataRes ? dataRes : {};
        const arr = dt.bill ? dt.bill : [];
        const customer_details = dt.customer_details ? dt.customer_details : {};
        const obj = arr[0] ? arr[0] : {};
        setReceiptData({
          ...receiptData,
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
        setOpenDialog(true);
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setReceiptData({ ...receiptData, loading: "error" });
      });
  };
  const validateRowsBeforeSave = () => {
    for (let idx = 0; idx < rows.length; idx++) {
      const item = rows[idx];
  
      if (!item.product_name || !item.batch_id || !item.product_quantity) {
        actions.snackbarActions.infoSnackbar(`Row ${idx + 1} is incomplete.`,100000
        );
        return false;
      }
  
      // if (item.isError || item.isPriceLower) {
      //   actions.snackbarActions.infoSnackbar(`Row ${idx + 1}: of product ${item.product_name }  price cannot be lower than original price ${item.original_rate}`,100000);
      //   return false;
      // }
      if (item.isPriceLower) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
        actions.snackbarActions.infoSnackbar(`Row ${idx + 1}: for product ${item.product_name} So the price cannot be lower than original Price.`);
        return false;
      }
      if (item.isError ) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
        actions.snackbarActions.infoSnackbar(`Row ${idx + 1}: for product ${item.product_name} So the Quantity cannot be lower .`);
        return false;
      }  
  
      if (item.isDiscountable) {
        actions.snackbarActions.infoSnackbar(`Row ${idx + 1}: of product ${item.product_name } discount cannot exceed rate.`,100000);
        return false;
      }
    }
  
    return true; // all rows are valid
  };
  
  
  const handleSaveReceipt = (event) => {
    event.preventDefault();
    setSubmitted(true);
    // alert("am here .. ")
  
    const validate_invoice_date = validateCurrentDate(state.invoice_date);
    const { paid_amount, n_total, due_amount, change } = totals;
    const { credit_limit } = customerDetails;
    const { customer_id } = customer;
  
    // 1️⃣ Validate rows
    const isRowsValid = validateRowsBeforeSave();
if (!isRowsValid) return; // Stop saving

  
    // 2️⃣ Validate main form fields
    if (!paid_amount || !paytype || paid_amount < n_total || !validate_invoice_date) {
      actions.snackbarActions.errorSnackbar("Please fix all required fields before saving.");
      return;
    }
    if (!customer_id){
      actions.snackbarActions.infoSnackbar({
        message: `Please Select A customer`,
        duration: 100000,
      });
      return;
    }
  
    // 3️⃣ Validate credit limit
    if (due_amount > credit_limit && credit_limit !== 0) {
      actions.snackbarActions.infoSnackbar({
        message: `The customer has reached their credit limit of ${credit_limit.toLocaleString()}. Please clear the balance before purchasing more items`,
        duration: 100000,
      });
      return;
    }
  
    // ✅ Everything is valid — proceed to save
    setIsSubmitted("pending");
    setIsBlocking(false);
  
    const data = rows.map((row) => ({
      product_id: row.product_id,
      batch_id: row.batch_id,
      quantity: row.product_quantity,
      rate: row.product_rate,
      id: row.related_product,
      discount: row.discount ?? 0,
      discount_rate: row.discount_rate ?? 0,
      discount_amount: row.discount_amount ?? 0,
      batch_details_id: row.batch_details_id ?? null,
    }));
  
    const amount_paid = paid_amount > n_total ? n_total : paid_amount;
  
    axios
      .post(
        `${config.epharmUrl}/Cinvoice/insert_invoice`,
        {
          payment_type: 1,
          payment_method: +paytype,
          customer_id,
          total_amount: n_total,
          amount_paid,
          bill_details: data,
          invoice_date: state.invoice_date,
          balance: change,
          is_wholesale: false,
        },
        { headers: { user_id } },
      )
      .then((response) => {
        const dt = response.data?.data?.[0] ?? {};
        const recep = dt.receipt ?? {};
        const recep_id = recep.receipt_no ?? "";
        const cus_id = dt.customer_id ?? "";
  
        retrieveReceiptDetails({ receipt_number: recep_id, customer_id: cus_id });
        actions.snackbarActions.successSnackbar("Receipt saved successfully!");
        setIsSubmitted("resolved");
        setSubmitted(false);
        setRows(initialState);
        setCustomer({ customer_name: "Walk-in Customer", customer_id: cus_id });
        setTotals({ grand_total_price: 0, n_total: 0, change: 0, due_amount: 0, paid_amount: "", previous_amount: 0, total_discount_amount: 0 });
        setCustomerDetails({ credit_limit: 0 });
        setInvoiceId(recep_id);
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setIsSubmitted("rejected");
      });
  };
    
  // const handleSaveReceipt = (event) => {
  //   event.preventDefault();
  //   const { paid_amount, n_total, due_amount, change } = totals;
  //   const { credit_limit } = customerDetails;
  //   const { customer_id } = customer;
  //   const { invoice_date } = state;
  //   setSubmitted(true);
  //   const arr =  rows.every((item) => item.batch_id && item.product_name && item.product_quantity && !item.isDiscountable);
  //   const validate_invoice_date = validateCurrentDate(invoice_date);

  //   // console.log(rows)
  // // NEW: Check if any row has an invalid rate (price lower than original)
  // const hasInvalidPrice = rows.some((item) => item.isError);
  // if (hasInvalidPrice) {
  //   actions.snackbarActions.errorSnackbar(
  //     "Cannot save receipt: some product prices are lower than the original."
  //   );
  //   return; // stop execution, prevent saving
  // }

  //   // Validate rows before saving
  //   const isRowsValid = validateRowsBeforeSave();
  //   if (!isRowsValid) return; // Stop saving if validation fails
  
  //   if (!paid_amount || !paytype || paid_amount < n_total || !validate_invoice_date) {
  //     actions.snackbarActions.errorSnackbar("Please fix all required fields before saving.");
  //     return;
  //   }
  //   // debugger;

  //   if (
  //     arr &&
  //     paid_amount &&
  //     paytype &&
  //     paid_amount >= n_total &&
  //     validate_invoice_date
  //   ) {
  //     setIsSubmitted("pending");
  //     setIsBlocking(false);

  //     if (due_amount <= credit_limit || credit_limit === 0) {
  //       const data = rows.map((row) => ({
  //         ...row,
  //         product_id: row?.product_id,
  //         batch_id: row?.batch_id,
  //         quantity: row?.product_quantity,
  //         rate: row?.product_rate,
  //         id: row?.related_product,
  //         discount:row?.discount?? 0,
  //         discount_rate:row?.discount_rate?? 0,
  //         discount_amount:row?.discount_amount?? 0,
  //       }));

  //       const amount_paid = paid_amount > n_total ? n_total : paid_amount;
  //       // console.log("balance", change);
  //       axios
  //         .post(
  //           `${config.epharmUrl}/Cinvoice/insert_invoice`,
  //           {
  //             payment_type: 1,
  //             payment_method: +paytype,
  //             customer_id,
  //             total_amount: n_total,
  //             amount_paid,
  //             bill_details: data,
  //             invoice_date,
  //             balance: change,
  //             is_wholesale:false,
  //           },
  //           { headers: { user_id } },
  //         )
  //         .then((response) => {
  //           const data = response.data ?? {};
  //           const dt = data.data ? data.data : {};
  //           const recep = dt[0].receipt ? dt[0].receipt : "";
  //           const recep_id = recep.receipt_no ? recep.receipt_no : "";
  //           const cus_id = dt[0].customer_id ? dt[0].customer_id : "";
  //           retrieveReceiptDetails({
  //             receipt_number: recep_id,
  //             customer_id: cus_id,
  //           });
  //           actions.snackbarActions.successSnackbar(
  //             "Receipt saved successfully!",
  //           );
  //           setIsSubmitted("resolved");
  //           setSubmitted(false);
  //           setRows(initialState);
  //           setCustomer({
  //             customer_name: "Walk-in Customer",
  //             customer_id: cus_id,
  //           });
  //           setTotals({
  //             grand_total_price: 0,
  //             n_total: 0,
  //             change: 0,
  //             due_amount: 0,
  //             paid_amount: "",
  //             previous_amount: 0,
  //             total_discount_amount: 0,
  //           });
  //           setCustomerDetails({ credit_limit: 0 });
  //           setInvoiceId(recep_id);
  //         })
  //         .catch((error) => {
  //           errorMessages(error, null, actions);
  //           setIsSubmitted("rejected");
  //         });
  //     } else {
  //       let msg = {
  //         message: `The customer has reached their credit limit of
  //            ${credit_limit.toLocaleString()}. Please clear the balance before purchasing more items`,
  //         duration: 10000,
  //       };
  //       actions.snackbarActions.infoSnackbar(msg);
  //     }
  //   }
  // };

  const handleCloseSnackbar = () => {
    actions.snackbarActions.hideSnackBar();
  };

  const handleViewReceipt = () => {
    history.push(`/receipt_print/${customer_id}/${invoice_id}`);
  };

  const isPending = isSubmitted === "pending";
  const isResolved = isSubmitted === "resolved";
  const isRejected = isSubmitted === "rejected";

  const addedState = { ...stateVariables, payTypes };

  return {
    submitted,
    stateFunctions,
    stateVariables: addedState,
    openDialog,
    invoice_id,
    isPending,
    isResolved,
    isRejected,
    handleCloseDialog,
    handleSaveReceipt,
    handleCloseSnackbar,
    handleViewReceipt,
    receiptData,
  };
};
